import { render, staticRenderFns } from "./companyRingChart.vue?vue&type=template&id=70adba54"
import script from "./companyRingChart.vue?vue&type=script&lang=js"
export * from "./companyRingChart.vue?vue&type=script&lang=js"
import style0 from "./companyRingChart.vue?vue&type=style&index=0&id=70adba54&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports